<template>
  <div class="login">
    <!-- 登录 -->
    <div id="content">
      <div class="logo">
        <img src='../assets/img/login/logo.png'/>
       </div>
      <form class="from_group" @submit.prevent="validateSubmit">
         <div class="input_group">
           <icon name="user" class="icon"></icon>
           <input type="tel" name="phone" v-model="phone" placeholder="请输入手机号" v-validate="'required|phone'" :class="{'input': true, 'is-danger': errors.has('phone') }">
         </div>
         <span v-show="errors.has('phone')" class="help is-danger">{{ errors.first('phone') }}</span>
         <div class="input_group">
           <icon name="lock" class="icon"></icon>
           <input type="password" ref="pw" name="password" v-model="password" placeholder="请输入密码" v-validate="'required|min:6|max:16'" :class="{'input': true, 'is-danger': errors.has('password') }">
           <icon name="eye" class="look" :class="{'lookType':!lookType}" @click.native="seePw()"></icon>
         </div>
         <span v-show="errors.has('password')" class="help is-danger">{{ errors.first('password') }}</span>
         <div class="btns">
           <a href="#" v-on:click="toChangePassword" class="forget">忘记密码？</a>
           <button type="submit" class="mui-btn mui-btn-primary is-primary login_btn">登录</button>
           <!-- <button type="button" class="weixin_btn" @click="wxLogin"><icon name='weixin'></icon> 微信登录</button> -->
           <button type="button" class="register_btn" v-on:click="register">10s注册新账户</button>
         </div>
      </form>

      <div class="second_part" v-if="false">
        <div class="part_title">
      	  <img src="../assets/img/login/3.png"/>
      	</div>
      	  <ul>
      		  <li class="qq"><img src="../assets/img/login/tx.png"/></li><li class="wx"><img src="../assets/img/login/wx.png"/></li><li class="wb"><img src="../assets/img/login/wb.png"/></li>
      		</ul>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast, Indicator } from 'mint-ui'
import bus from '../utiles/bus'
import Vue from 'vue' 
export default {
  name: 'home',
  data () {
    return {
      phone: '',
      password: '',
      lookType: 'false'
    }
  },
  mounted () {
    if (this.GetQueryString('code') !== null) {
      this.loadGetWeChatInfo(this.GetQueryString('code'), this.GetQueryString('state'))
    } else if (typeof WeixinJSBridge !== 'undefined') {
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx704e381641507864&redirect_uri=http%3a%2f%2f' + this.STATE.state.hosturl + '%2fpassport%2flogin&response_type=code&scope=snsapi_base&state=BASESTATE#wechat_redirect'
    }
  },
  methods: {
    // 微信授权链接
    wxLogin () {
      window.location.href = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx704e381641507864&redirect_uri=http://' + this.STATE.state.hosturl + '/passport/login&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect'
    },
    // 获取微信用户信息
    loadGetWeChatInfo (code, state) {
      let _this = this
      if (state === 'BASESTATE') {
        _this.STATE.state.wechatCode = code
      } else {
        this.axios({
          method: 'POST',
          url: '/url/api/getWeChatUserInfo',
          timeout: 100000,
          params: {
            code: code,
            state: state
          }
        }).then(function (res) {
          console.log('获取成功' + res)
          if (res.data.loginObj !== null) {
            if (res.data.loginObj.success) {
              _this.STATE.state.loginState = res.data.loginObj.success
              _this.STATE.state.loginPhone = res.data.loginUser.telephone
              _this.STATE.state.loginId = res.data.loginUser.id
              _this.$router.push({path: '/'})
              bus.$emit('routerBus','btnOne')
            }
          } else {
            var name = encodeURIComponent(res.data.nickname)
            _this.$router.push({path: '/my/binding/accountBind', query: { openid: res.data.openid, nickname: name }})
          }
        }).catch(function (res) {
          console.log('获取失败' + res)
        })
      }
    },
    // 获取url中的参数
    GetQueryString (name) {
      var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
      var r = location.search.substr(1).match(reg)
      if (r !== null) {
        return unescape(r[2])
      } else {
        return null
      }
    },
    // 生成随机数
    uuid (len, radix) {
      var chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
      var uuid = []
      if (radix !== null) {
        radix = chars.length
      }
      if (len) {
        for (var i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
      } else {
        var r
        uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
        uuid[14] = '4'
        for (i = 0; i < 36; i++) {
          if (!uuid[i]) {
            r = 0 | Math.random() * 16
            uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
          }
        }
      }
      return uuid.join('')
    },
    validateSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          Indicator.open({
            text: '登录中...',
            spinnerType: 'fading-circle'
          })
          let _this = this
          this.axios({
            method: 'post',
            url: '/url/api/ajaxSession',
            params: {
              name: _this.phone,
              password: _this.password,
              rememberMe: true
            }
          }).then(function (response) {
            Indicator.close()
            let msg = ''
            if (response.data.success) {
              _this.STATE.state.loginState = true
              _this.STATE.state.loginPhone = _this.phone
              _this.STATE.state.loginId = response.data.data.loginID
              _this.STATE.commit('setloginId',response.data.data.loginID)
              sessionStorage.setItem('loginState',true)
              msg = '登录成功'
              if (_this.$route.params.fromPath === '/project/myJobs') {
                _this.$router.push({path: _this.$route.params.fromPath, query: {select: 'myJob'}})
              } else if (_this.$route.params.fromPath === '/project/creatpjt' || _this.$route.params.fromPath === '/me' || _this.$route.params.fromPath === '/myJobs') {
                _this.$router.push({path: _this.$route.params.fromPath})
              } else if (_this.$route.params.fromPath === '/createProject') {
                bus.$emit('routerBus', _this.$route.params.icon)
                _this.$router.push({path: _this.$route.params.fromPath})
              } else if (_this.$route.params.fromPath === '/project/projectDetail') {
                _this.$router.push({path: _this.$route.params.fromPath, query: { projectid: _this.$route.params.projectId }})
              } else {
                bus.$emit('routerBus', 'btnOne')
                _this.$router.push({path: '/'})
              }
            } else {
              _this.STATE.state.loginState = false
              msg = response.data.msg
            }
            Toast({
              message: msg,
              position: 'middle',
              duration: 1000
            })
          }).catch(function (response) {
            Indicator.close()
            _this.STATE.state.loginState = false
            Toast({
              message: '登录失败',
              position: 'middle',
              duration: 1000
            })
          })
        }
      })
    },
    seePw (e) {
      console.log(this.$refs.pw.type)
      if (this.$refs.pw.type === 'password') {
        this.$refs.pw.type = 'text'
        this.lookType = false
      } else {
        this.$refs.pw.type = 'password'
        this.lookType = true
      }
    },
    register () {
      this.$router.push({path: '/passport/regist'})
    },
    toChangePassword () {
      this.$router.push({path: '/passport/resetPwd'})
    },
  }
}
</script>


<style scoped>
  #content{
    margin:55px auto 70px;
  }
  #content .logo{
    text-align:center;
    margin:45px 0 20px;
  }
  #content .logo img{
    width:105px;
  }
  .from_group{
    padding:0 10%;
  }
  .input_group{
    line-height:40px;
    background-color:#f9f9f9;
    padding-left:21px;
    padding-right:13px;
    -webkit-border-radiu:20px;
    -moz-border-radiu:20px;
    border-radius:20px;
    margin:5px auto;
  }
  .input_group input{
    margin-left:10px;
    background-color:#f9f9f9;
    border:none;
    outline:none;
    width:75%;
  }
  .look{
    float:right;
    margin-top:10px;
  }
  .input_group input::-webkit-input-placeholder{
    color: #b7c3ca;
  }
  .input_group input:-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input::-moz-placeholder{
  　color:#b7c3ca;
  }
  .input_group input:-ms-input-placeholder{
  　color:#b7c3ca;
  }
  .input_group .look{
    margin-left:5px;
  }
  .input_group svg{
    color:#7f8c97;
  }
  .btns{
   margin:15px auto 0;
  }
  .btns a{
    font-size:14px;
    color:#d1d3da;
    float:right;
    margin-bottom:15px;
  }
  .btns button{
    display:block;
    width:100%;
    line-height:40px;
    font-size:16px;
    padding:0;
    border:none;
    -webkit-border-radiu:20px;
    -moz-border-radiu:20px;
    border-radius:20px;
    margin-bottom:10px;
    outline:none;
  }
  .btns .login_btn{
    color:#fff;
    background-color:#108ee9;
  }
  .btns .register_btn{
    color:#108ee9;
    background-color:#ebf5ff;
  }
  .second_part{
    text-align:center;
    margin-bottom:80px;
  }
  .second_part .part_title{
    width:70%;
    margin:10% auto 0;

  }
  .second_part .part_title img{
    width:100%;
  }
  .second_part ul{
    display:inline-block;
    margin-top:25px;
    overflow:hidden;
  }
  .second_part ul li{
    width:43px;
    height:43px;
    float:left;
    margin:0 25px;
  }
  .second_part ul li img{
    width:100%;
    height:100%;
  }
  .help{
    display:block;
    width:80%;
    margin:0 auto;
    font-size:14px;
    color:red;
  }
  .lookType{
    color:#108ee9!important;
  }
  .weixin_btn{
    color: #fff;
    background-color:	#32CD32;
  }
</style>



// WEBPACK FOOTER //
// login.vue?76d38940